import { FormValidationRule } from "../types";

const re = new RegExp(/^\d+$/i);

const integersOnly: FormValidationRule = (c, v) => {
    const chars = c["cssClass"] === "integer-only";
    const valid = !(chars && v && !re.test(v));
    return [valid, c.errorMessage || "You've entered an invalid character"];
};

export default integersOnly;
